import { ENUM_MortgagePartStepType } from '@api-new/common';

export const ENUM_MortgagePartStepTypeRecord: Record<ENUM_MortgagePartStepType, string> = {
  [ENUM_MortgagePartStepType.MORTGAGE_PART_STEP_TYPE_UNSPECIFIED]: 'Unspecified',
  [ENUM_MortgagePartStepType.MORTGAGE_PART_STEP_TYPE_FIXED]: 'Fixed',
  [ENUM_MortgagePartStepType.MORTGAGE_PART_STEP_TYPE_VARIABLE]: 'Variable',
  [ENUM_MortgagePartStepType.UNRECOGNIZED]: 'Unrecognized',
};
